
document.addEventListener('DOMContentLoaded', () => {
  const menus = document.querySelectorAll('.mega-menu');
  const overlay = document.createElement('div');
  overlay.className = 'mega-menu-overlay';
  document.body.appendChild(overlay);

  let activeMenu = null;
  let closeTimeout;

  const showOverlay = () => {
    overlay.style.display = 'block';
    requestAnimationFrame(() => {
      overlay.classList.add('active');
    });
  };

  const hideOverlay = () => {
    overlay.classList.remove('active');
    // setTimeout(() => {
      overlay.style.display = 'none';
    // }, 300);
  };

  const closeMenu = (menu) => {
    if (menu && menu.open) {
      const content = menu.querySelector('.mega-menu__content');
      if (content) {
        content.style.opacity = '0';
        content.style.transform = 'translateY(10px)';
        content.style.pointerEvents = 'none';

        // setTimeout(() => {
          menu.open = false;
          activeMenu = null;
          hideOverlay();
        // }, 300);
      } else {
        menu.open = false;
        activeMenu = null;
        hideOverlay();
      }
    }
  };

  const handleMouseEnter = (e) => {
    const menu = e.currentTarget;
    clearTimeout(closeTimeout);

    if (activeMenu && activeMenu !== menu) {
      closeMenu(activeMenu);
    }

    menu.open = true;
    activeMenu = menu;
    showOverlay();

    const content = menu.querySelector('.mega-menu__content');
    if (content) {
      content.style.opacity = '1';
      content.style.transform = 'translateY(0)';
      content.style.pointerEvents = 'auto';
    }
  };

  const handleMouseLeave = (e) => {
    const menu = e.currentTarget;
    // closeTimeout = setTimeout(() => {
      closeMenu(menu);
    // }, 200);
  };

  menus.forEach((menu) => {
    menu.addEventListener('mouseenter', handleMouseEnter);
    menu.addEventListener('mouseleave', handleMouseLeave);

    const summary = menu.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', (e) => {
        if (window.innerWidth < 1024) {
          e.preventDefault();
          menu.open = !menu.open;
          if (menu.open) {
            showOverlay();
          } else {
            hideOverlay();
          }
        }
      });
    }
  });

  overlay.addEventListener('click', () => {
    closeMenu(activeMenu);
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.mega-menu')) {
      closeMenu(activeMenu);
    }
  });
});
